import { render, staticRenderFns } from "./DerbyPlayerLink.vue?vue&type=template&id=2c8d27bc&"
import script from "./DerbyPlayerLink.vue?vue&type=script&lang=js&"
export * from "./DerbyPlayerLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports